import { Area, Guide, Tour } from "@agp/shared.user-app/entity";
import { useCallback, useState } from "react";
import { MonotoneTourContainer } from "./monotone-tour-container";
import { useLanguageBasedFont } from "../const/font-utils";
import { twMerge } from "tailwind-merge";

type MonotoneAreaContainerProps = {
  area: Area;
  tours: Tour[];
  guides: Guide[];
};

export const MonotoneAreaContainer = (props: MonotoneAreaContainerProps) => {
  const { area, tours, guides } = props;
  const [isImageLoading, setIsImageLoading] = useState(true);
  const fontClass = useLanguageBasedFont();

  const handleImageLoad = useCallback(() => {
    setIsImageLoading(false);
  }, []);

  const handleImageError = useCallback(() => {
    setIsImageLoading(false);
  }, []);

  return (
    <div className={`flex flex-col ${fontClass}`}>
      <div className={"p-2 flex flex-col"}>
        <div className={"relative w-full rounded-3xl overflow-hidden"}>
          {area.thumbnailUrl && (
            <div className={"mt-12"}>
              {isImageLoading && (
                <div
                  className={
                    "w-full h-[280px] rounded-3xl bg-gray-200 animate-pulse"
                  }
                />
              )}
              <img
                className={`w-full rounded-3xl bg-gray-200 flex justify-center items-center text-2xl ${
                  isImageLoading
                    ? "opacity-0 absolute top-0 left-0"
                    : "opacity-100"
                }`}
                src={area.thumbnailUrl}
                alt={area.name}
                onLoad={handleImageLoad}
                onError={handleImageError}
              />
            </div>
          )}
        </div>
        <div
          className={twMerge(
            `mt-8 ${fontClass} text-[18px] font-bold`,
            tours.length > 0 ? "text-[18px]" : "text-[20px]"
          )}
        >
          {area.description}
        </div>
      </div>
      {tours.length > 0 && (
        <div className={"mt-2 flex gap-2 flex-col"}>
          {tours.map((tour) => {
            const tourGuides = guides.filter(
              (guide) => guide.tourId === tour.id
            );
            return (
              <>
                <MonotoneTourContainer
                  key={tour.id}
                  tour={tour}
                  guides={tourGuides}
                />
              </>
            );
          })}
        </div>
      )}
    </div>
  );
};
